import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';
import { Eye, MessageSquare, Scale, GitMerge } from 'lucide-react';
const BENEFITS = [{
  icon: Eye,
  title: 'Advice before signing',
  desc: 'Risks, special conditions and obligations explained while you can still act on them.'
}, {
  icon: MessageSquare,
  title: 'Plain-English explanations',
  desc: 'What the contract actually means for your situation, without the legal fog.'
}, {
  icon: Scale,
  title: 'Legal capability when it counts',
  desc: 'The authority and experience to handle a matter when it moves past paperwork.'
}, {
  icon: GitMerge,
  title: 'One coordinated process',
  desc: 'The same team from first contract review through to settlement and completion.'
}];
export function Differentiation() {
  return <section className="py-20 md:py-28 px-5 md:px-6 bg-cream" data-id="element-224">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start" data-id="element-225">
        <div className="lg:col-span-5 lg:sticky lg:top-28" data-id="element-226">
          <p className="text-accent font-script text-2xl mb-1" data-id="element-227">
            the honest bit
          </p>
          <h2 className="text-3xl md:text-[2.6rem] leading-tight text-ink" data-id="element-228">
            Conveyancing is routine, until it isn't.
          </h2>
          <p className="mt-6 text-lg text-muted-ink leading-relaxed" data-id="element-229">
            A transaction can change quickly when a title issue, an unsuitable
            special condition, a disclosure problem or an ownership-structure
            question appears. L.A Property Law combines conveyancing process
            management with access to legal advice when the matter needs more
            than paperwork.
          </p>
          <div className="mt-8" data-id="element-230">
            <Link to="/about" data-id="element-231">
              <Button variant="primary" data-id="element-232">See how we work</Button>
            </Link>
          </div>
        </div>

        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-233">
          {BENEFITS.map(b => {
          const Icon = b.icon;
          return <div key={b.title} className="rounded-3xl bg-surface border border-border p-7 shadow-card" data-id="element-234">
                <div className="inline-flex w-12 h-12 items-center justify-center rounded-2xl bg-brand-blue-light text-brand-blue mb-5" data-id="element-235">
                  <Icon className="w-6 h-6" strokeWidth={2} data-id="element-236" />
                </div>
                <h3 className="font-serif text-xl text-ink mb-2" data-id="element-237">{b.title}</h3>
                <p className="text-muted-ink leading-relaxed" data-id="element-238">{b.desc}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}